export { DealerContext, type DealerContextData, type DealerOption } from './Context';
export { useDealerContext, useSingleDealerId, useMultipleDealerIds } from './hooks';
export { DealerContextManager, type DealerContextManagerProps } from './Manager';
